import React, { useCallback, useMemo } from 'react';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import useSelector from '../../utils/hooks/useSelector';
import { COMMON_EXCLUDED_FOR_MANAGER } from '../../utils/constants';

const { SubMenu } = Menu;

function VerticalNav({ onClick }) {
  const { globalCounters } = useSelector((state) => state.counter);
  const { user } = useSelector((state) => state.users);
  const history = useHistory();
  const menu = [
    {
      title: 'Заказы',
      to: '/waybills',
    },
    {
      title: 'Задачи',
      to: '/attention?status=active',
      counter: globalCounters.attentions,
    },
    {
      title: 'Тарифы',
      to: '/rates',
      children: [
        {
          title: 'Тарифы',
          to: '/rates',
        },
        {
          title: 'Маркетинг',
          to: '/rates/marketing',
        },
      ],
    },
    {
      title: 'Отчет по статусам',
      to: '/report',
    },
  ];

  const renderMenu = useCallback(
    (item) => {
      if (item.children && item.children.length) {
        return (
          <>
            <Menu.Item className="ant-menu-item ant-menu-submenu ant-menu-submenu-vertical gx-menu-vertical ant-menu-submenu-vertical">
              <Link className="ant-menu-submenu-title" to={item.to} onClick={onClick}>
                <span>{item.title}</span>
                <i className="ant-menu-submenu-arrow"/>
              </Link>
            </Menu.Item>
            {item.children.map((i) => (
              <div style={{ padding: '0 30px' }}>
                <Menu.Item key={i.to} className="ant-menu-item ant-menu-submenu ant-menu-submenu-vertical gx-menu-vertical">
                  <Link className="ant-menu-submenu-title" to={i.to || '/'} onClick={onClick}>
                    {i.title}
                  </Link>
                </Menu.Item>
              </div>
            ))}
          </>
        )
      }
      return (
        <Menu.Item className="ant-menu-submenu ant-menu-submenu-vertical gx-menu-vertical">
          <Link className="ant-menu-submenu-title" to={item.to} onClick={onClick}>
            <span>{item.title}</span>
          </Link>
        </Menu.Item>
      );
    }, [menu],
  );

  const filteredMenu = useMemo(() => {
    return menu.filter(item => {
      if (user && user.isManager && !user.isAdmin && item.to) {
        return !COMMON_EXCLUDED_FOR_MANAGER.includes(item.to);
      }
      return true
    })
  }, [user, globalCounters])


  return (
    <Menu
      className="ant-menu-dark ant-menu-light ant-menu-root ant-menu-vertical"
      mode="vertical"
    >
      {filteredMenu.map((item) => renderMenu(item))}
    </Menu>


  );
}

export default VerticalNav;
